import { gql } from '@apollo/client';
import { FR_ASSET_FIELDS } from './asset';

export const FR_ISSUE_STATUS_FIELDS = gql`
    fragment fr_IssueStatusFields on IssueStatus {
        IssueStatusId
        Name
    }
`;

export const FR_ISSUES_FIELDS = gql`
    fragment fr_IssueFields on Issue {
        IssueId
        Description
        Summary
        x
        y
        ObservationDate
        AssetName
        AssetType
        NextScheduledMaintenance
        LinkedToServiceDate
        Impact
        Environmental
        Locale
        ItemNumber
        CorrectionProposal
        CorrectionAction {
            IssueCorrectionActionId
            Action
            ProcedureTime
        }
        History {
            IssueHistoryId
            Description
            Created
            User {
                UserId
                Firstname
                Lastname
                Fullname
            }
            Source
            Action
        }
        Project {
            ProjectId
            Name
            ProjectNbr
        }
        IssueStatus {
            ...fr_IssueStatusFields
        }
        Asset {
            ...fr_AssetFields
        }
        ServiceEntry {
            ServiceEntryId
            Name
        }
        IssueUser {
            IssueUserId
            IssueUserType {
                IssueUserTypeId
                Name
            }
            User {
                UserId
                Firstname
                Lastname
                Fullname
            }
            Created
        }
        Access {
            Read
            Create
            Delete
            Update
        }
        IssueType
        Private
        EquipmentIssueCount
        Created
        Updated
        Resolved
        ServiceEntry {
            ServiceEntryId
            Name
        }
        Note
        IssueSource {
            IssueSourceId
            Name
        }
        Due
        IssuePriority {
            IssuePriorityId
            Name
        }
        ServiceWork {
            Name
            sv_Name: Name(LangCode: SV)
            en_Name: Name(LangCode: EN)
            no_Name: Name(LangCode: NO)
            Description
            sv_Description: Description(LangCode: SV)
            en_Description: Description(LangCode: EN)
            no_Description: Description(LangCode: NO)
            ServiceTask {
                IsResolvingIssue
                Name
                sv_Name: Name(LangCode: SV)
                en_Name: Name(LangCode: EN)
                no_Name: Name(LangCode: NO)
                Description
                sv_Description: Description(LangCode: SV)
                en_Description: Description(LangCode: EN)
                no_Description: Description(LangCode: NO)
                ServiceTaskId
            }
            ServiceWorkId
        }
        Category {
            CategoryId
            Name
        }
        Assembly {
            AssemblyId
            Name
        }
        Component {
            ComponentId
            Name
        }
    }
    ${FR_ASSET_FIELDS}
    ${FR_ISSUE_STATUS_FIELDS}
`;

export const FR_ISSUE_LIST_FIELDS = gql`
    fragment fr_IssueListFields on Issue {
        IssueId
        Description
        Summary
        IssueStatus {
            Name
        }
        ServiceEntry {
            ServiceEntryId
        }
        IssueType
        Created
    }
`;

/*export const FR_ISSUE_FOLDER_FIELDS = gql`
    fragment fr_IssueFolderFields on Folder {

    }
`*/
